import { PushNotificationType } from "../../middleware/Constants/ApplicationTypes";

const DURATION_30_DAYS_IN_SECONDS = 3600 * 24 * 30;

export const getAndroidPn = (apns) => {
    if (!apns) {
        return null;
    }

    let fcm = null;
    apns.forEach(pn => {
        if (pn.type === PushNotificationType.Fcm || pn.type === PushNotificationType.FcmXmpp) {
            fcm = pn;
        }
    });
    return fcm;
};

export const getIosPns = (apns, type) => {
    if (!apns) {
        return null;
    }

    let pns = null;
    apns.forEach(pn => {
        if (pn.type === (PushNotificationType.Apns) && pn.certificateType === type) {
            pns = pn;
        }
    });
    return pns;
};

export const getIosPnsV2 = (apns) => {
    if (!apns) {
        return null;
    }

    let pns = null;
    apns.forEach(pn => {
        if (pn.type === PushNotificationType.ApnsV2) {
            pns = pn;
        }
    });
    return pns;
};

export const getAuthorizationKey = (apn) => {
    if (!apn || !apn.authorizationKey) {
        return "";
    }
    return apn.authorizationKey;
};

export const isEnabled = (apn) => {
    if (!apn) {
        return false;
    }
    return apn.isEnabled;
};

export const getSenderId = (apn) => {
    if (!apn || !apn.senderId) {
        return "";
    }
    return apn.senderId;
};

export const isFcmType = (apn) => {
    if (!apn) {
        return false;
    }
    return apn.type === PushNotificationType.Fcm;
};

export const getCertificateType = (apn, defaultType) => {
    if (!apn) {
        return defaultType;
    }
    return apn.certificateType;
};

export const getCertificateFingerPrint = (apn) => {
    if (!apn) {
        return "";
    }
    return apn.certificateFingerprint;
};

export const getApplicationBundleId = (apn) => {
    if (!apn) {
        return "";
    }
    return apn.appBundleId;
};

export const getCertificateExpirationDate = (apn) => {
    if (!apn || !apn.certificateExpirationTime) {
        return "";
    }
    return apn.certificateExpirationTime;
};

export const getPrettyCertificateExpirationDate = (apn, intl) => {
    const certificateExpiration = getCertificateExpirationDate(apn);
    if (certificateExpiration && certificateExpiration.length > 0) {
        return intl.formatDate(certificateExpiration, { year: "numeric", month: "short", day: "numeric" });
    }
    return "";
};

export const isCertificateExpired = (apn) => {
    const certificateExpiration = getCertificateExpirationDate(apn);
    if (certificateExpiration && certificateExpiration.length > 0) {
        const expirationDate = new Date(certificateExpiration);
        if (expirationDate < new Date()) {
            return true;
        }
    }
    return false;
}

export const hasExpiredCertificate = (apns) => {
    if (!apns || apns.length === 0) {
        return false;
    }
    let expired = false;
    apns.forEach(pn => {
        if (isCertificateExpired(pn)) {
            expired = true;
        }
    });
    return expired;
}

export const willCertificateExpireWithin30Days = (apn) => {
    if (!apn) {
        return false;
    }
    const certificateExpirationDate = getCertificateExpirationDate(apn);
    if (certificateExpirationDate && certificateExpirationDate.length > 0) {
        const expirationDate = new Date(certificateExpirationDate);
        const expirationDate30Days = new Date(expirationDate.getTime() - DURATION_30_DAYS_IN_SECONDS * 1000);
        if (expirationDate30Days < new Date()) {
            return true;
        }
    }
    return false;
}

export const hasCertificateExpireWithin30Days = (apns) => {
    if (!apns || apns.length === 0) {
        return false;
    }
    let expired = false;
    apns.forEach(pn => {
        if (willCertificateExpireWithin30Days(pn)) {
            expired = true;
        }
    });
    return expired;
}